//search drawer open js start
function searchDrawerClose() {
    document.body.classList.remove("search_drawer_open");
}
//search drawer open js end
$(document).ready(function(){
      // Function to fetch cart quantity
    function fetchCartQuantity() {
      return $.getJSON('/cart.js').then(function (cart)
      {
        return cart; // Total number of items in the cart
        //console.log('cart => ' + cart)
      });
    }
// fetchCartQuantity();
    // Log cart quantity on each body click
    $('body').on('click', function () {
      fetchCartQuantity().then(function (cart_items) {
        console.log('cart_items:', cart_items);
           $('#cart_nav .cart-count-bubble span').text(cart_items.item_count);  
      });
    });
  //scrolltop js start
    $("#top_nav").click(function(){
        $("html, body").animate({ scrollTop: 0 }, "slow");
        return false;
    });
   //scrolltop js start

  // cart-nav toggle start
    $('#cart_nav').on('click', function(){
      $('cart-drawer.drawer').toggleClass('active');
      $('body').toggleClass('overflow-hidden');
    });
  // cart-nav toggle end
  
  // search nav toggle start
  $('#search_nav, .header_search_mobo').on('click', function(){
      $('body').toggleClass('search_drawer_open');
      
      // var detailsElement = $('.header_search_mobo details');
      
      // if (detailsElement.attr('open')) {
      //     detailsElement.removeAttr('open'); // Remove 'open' if it exists
      // } else {
      //     detailsElement.attr('open', true); // Add 'open' if it's not there
      // }
  });
  // search nav toggle end
});
